import { useQuery } from '@apollo/client';
import React, { Fragment, useEffect } from 'react';
import Video from './Video';
import PropTypes from 'prop-types';
import { EVideoUploadStatus } from 'FeatureModules/Media/types/media.types';
import { GET_VIDEOS } from 'graphql/secure/queries';

const VideoList = ({ videos }) => {
  const {
    data: unfinishedVideos,
    startPolling,
    stopPolling,
  } = useQuery(GET_VIDEOS, {
    variables: {
      filters: {
        uploadStatus: EVideoUploadStatus.INITIATED,
      },
    },
  });

  // If the transcoding videos no longer contain any videos, this will stop the polling mechanism so videos won't be fetched
  useEffect(() => {
    if (
      videos?.some(({ uploadStatus }) => uploadStatus === EVideoUploadStatus.INITIATED) ||
      unfinishedVideos?.videos?.edges.length
    ) {
      startPolling(2500);
    } else {
      stopPolling();
    }
  }, [videos, unfinishedVideos]); // eslint-disable-line

  return (
    <>
      {videos.map(({ node: video }) => {
        return <Video key={video.id} video={video} />;
      })}
    </>
  );
};

VideoList.propTypes = {
  videos: PropTypes.array.isRequired,
};

export default VideoList;
